var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 72,
    viewBox: "0 0 188 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5641 67.1592C64.4802 64.154 81.7459 59.5736 99.8872 53.616C118.548 47.4955 135.589 40.7459 149.607 34.159C174.525 22.4594 189.89 11.2481 187.813 4.92086C185.78 -1.30517 167.04 -1.48557 140.733 3.60086C141.442 4.70086 142.117 5.83167 142.757 6.99328C142.994 7.42741 143.227 7.86741 143.456 8.31328C157.466 6.51807 166.75 7.33648 168.013 11.1909C169.276 15.0453 162.073 21.377 149.365 28.3642C136.931 35.2018 119.239 42.7083 99.1656 49.2951C79.0927 55.882 60.3222 60.3304 46.2377 62.174C31.92 64.066 22.4027 63.2784 21.1223 59.3668C19.8683 55.53 26.8424 49.3919 39.1008 42.5499C38.7921 40.6854 38.5879 38.8051 38.4892 36.9179C13.7127 48.5867 -1.881 60.1852 0.182609 66.4948C2.29022 72.9189 21.8791 72.7385 49.5641 67.1592Z",
    fill: "#84E2D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector13);
export default __webpack_public_path__ + "static/media/vector-13.ba955c37e34750bd9ef08d1539e01105.svg";
export { ForwardRef as ReactComponent };